import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faTwitter,
  faInstagram,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import MoreSvg from 'images/svg_js/More';
import { toggleTermsOfServicesModal } from 'store/modules/modals';

class FixedFooter extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
    };
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  render() {
    const { toggleTermsOfServicesModal } = this.props;
    return (
      <div className="footer-fixed">
        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
          <DropdownToggle className="footer-btn">
            <div className="footer-btn__text">
              Privacy, Help, Upgrade & More
            </div>
            <div className="footer-btn__icon">
              <MoreSvg />
            </div>
          </DropdownToggle>
          <DropdownMenu>
            <div className="footer-fixed__itm">
              <Link to="/privacy" className="footer-fixed__link">
                Privacy & Policy
              </Link>
            </div>
            <div className="footer-fixed__itm">
              <span
                onClick={toggleTermsOfServicesModal}
                className="footer-fixed__link">
                Terms of use
              </span>
            </div>
            <div className="footer-fixed__itm">
              <Link to="/faq" className="footer-fixed__link">
                Help and FAQ
              </Link>
            </div>
            <div className="footer-fixed__itm">
              <Link to="/contact" className="footer-fixed__link">
                Contact Us
              </Link>
            </div>
            <div className="drop-nav-separator" />
            <div className="footer-fixed__itm">
              <a
                href="https://www.instagram.com/instalinks_official/"
                className="footer-fixed__link">
                <div className="footer-fixed__icon">
                  <FontAwesomeIcon
                    className="btn-checkbox__icon facebook"
                    icon={faInstagram}
                  />
                </div>
                Instagram
              </a>
            </div>
            <div className="footer-fixed__itm">
              <a
                href="https://www.facebook.com/InstaLinksOfficial"
                className="footer-fixed__link">
                <div className="footer-fixed__icon">
                  <FontAwesomeIcon
                    className="btn-checkbox__icon facebook"
                    icon={faFacebook}
                  />
                </div>
                Facebook
              </a>
            </div>
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}

const mapDispatchToProps = {
  toggleTermsOfServicesModal,
};

export default connect(
  null,
  mapDispatchToProps,
)(FixedFooter);



// WEBPACK FOOTER //
// ./src/components/FixedFooter/FixedFooter.js